import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  private baseUrl = `${environment.apiUrlV2}/report`;
  private baseUrl2 = `${environment.apiUrlV2}/`;
  private baseUrl3 = `${environment.apiUrlV3}/report`;
  private baseUrl4 = `${environment.apiUrlV4}/`;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  
  constructor(private http: HttpClient) { }

  getQuestions(insuranceId,segment,surveyType) {
    return this.http
      .get<any>(`${this.baseUrl}/${insuranceId}/${segment}/${surveyType}`, {
        headers: this.headers,
      })
      .toPromise();
  }

  getImages(insuranceId) {
    return this.http
      .get<any>(`${this.baseUrl}/${insuranceId}/files`, {
        headers: this.headers,
      })
      .toPromise();
  }


  resizeImage(id) {
    return this.http
      .post<any>(`${this.baseUrl}/${id}/resizeFile/90`, {
        headers: this.headers,
      })
      .toPromise();
  }

  filterByInspection(inspectionId) {
    return this.http
      .get<any>(`${this.baseUrl}/filterByInspection/${inspectionId}`, {
        headers: this.headers,
      })
      .toPromise();
  }

  reportReponse(reportId,body){
      return this.http
        .post<any>(`${this.baseUrl}/${reportId}/response`, body, {
          headers: this.headers,
        })
        .toPromise();
  }

  updateReportReponse(reportId,body){
    return this.http
      .put<any>(`${this.baseUrl}/${reportId}/update/response`, body, {
        headers: this.headers,
      })
      .toPromise();
  }

  insertReportReponseBatch(body){
    return this.http
      .post<any>(`${this.baseUrl}/batch/response`, body, {
        headers: this.headers,
      })
      .toPromise();
  }

  addReport(body){
    return this.http
      .post<any>(`${this.baseUrl}`, body, {
        headers: this.headers,
      })
      .toPromise();
  }

  update(body,reportId){
    return this.http
    .put<any>(`${this.baseUrl}/${reportId}/update`, body, {
        headers: this.headers,
      })
      .toPromise();
  }

  updateHistoric(body){
    return this.http
    .post<any>(`${this.baseUrl2}inspectionHistory`, body, {
        headers: this.headers,
      })
      .toPromise();
  }

  updateHistoricAdd(body){
    return this.http
    .post<any>(`${this.baseUrl4}Inspection/ProviderInspectionHistoryAdd`, body, {
        headers: this.headers,
      })
      .toPromise();
  }

  addFile(body,reportId,typeFile,insuranceGroupFileId){
    let header = new HttpHeaders({
      'Accept': '*'
    })
    return this.http
      .post<any>(`${this.baseUrl}/${reportId}/importFile/${typeFile}/${insuranceGroupFileId}`, body, {
        headers: header,
      })
      .toPromise();
  }

  getFilesGroup(insuranceId,segment,surveyType,reportId){
    return this.http
      .get<any>(`${this.baseUrl3}/getInsuranceGroupFileByInsuranceId/${insuranceId}/${segment}/${surveyType}/${reportId}`, {
        headers: this.headers,
      })
      .toPromise();
  }
  
  getHistoric(inspectionId){
    return this.http
      .get<any>(`${this.baseUrl2}inspectionHistory/${inspectionId}/`, {
        headers: this.headers,
      })
      .toPromise();
  }

  deleteFile(id) {
    return this.http
      .delete<any>(this.baseUrl + '/' + id, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  updateInsuranceCustomerData(body: any) {
    return this.http
      .put<any>(`${environment.apiUrlV3}/Inspection/ResendLinkUpdateInspection/${body.id}`, body, {
        headers: this.headers,
      });
  }

  deleteReportByInspectionId(inspectionId: string): Promise<any> {
    return this.http
      .delete<any>(`${this.baseUrl}/inspection/${inspectionId}`, {
        headers: this.headers,
      })
      .toPromise();
  }

  getReportDeletionLogs(top: number = 10) {
    return this.http.get<any>(
      `${this.baseUrl}/deletionLogs`,
      {
        headers: this.headers,
        params: { top: top.toString() }
      }
    );
  }

  exportReportDeletionLogs(): Promise<Blob> {
    return this.http
      .get(
        `${this.baseUrl}/deletionLogs/export`,
        {
          headers: this.headers,
          responseType: 'blob'
        }
      )
      .toPromise();
  }
  
}
